<script>
  export let size;
  export let title;
  export let slideWidth;
  export let paraHeight;
  export let eventIndex;
  export let isReversedDueToLength = false;
  export let maxIndex = null;
  export let active;
  export let activeViaHover;

  import { isMobile, windowWidth, iconSizeLookup } from "../stores/global.js";

  import Small from "./Typography/Small.svelte";
  import Medium from "./Typography/Medium.svelte";
  import Large from "./Typography/Large.svelte";

  const componentLookup = {
    Small: Small,
    Medium: Medium,
    Large: Large,
  };

  const desktopTitleWidth = 300;

  $: textWidth = function () {
    if ($isMobile) {
      if (slideWidth * 2 * 1.5 > $windowWidth * 0.6) {
        return $windowWidth * 0.6;
      } else {
        return slideWidth * 2 * 1.5;
      }
    } else if (slideWidth * 2 * 1.5 > desktopTitleWidth) {
      return desktopTitleWidth;
    } else {
      return slideWidth * 2 * 1.5;
    }
  };

  // Never swap text on mobile, because it's left aligned
  let isSwapped = $isMobile ? false : eventIndex % 2 == 1;

  $: opacityHoverDelay = activeViaHover
    ? 0
    : 400 + (isReversedDueToLength ? maxIndex - eventIndex : eventIndex) * 100;
  // let opacityHoverDelay = 400;
</script>

<div
  class="title {isSwapped ? 'swapped' : ''} 
               {active ? 'active' : 'inactive'}"
  style="width: {textWidth() + 'px'}; 
        right: {isSwapped ? `calc(${$iconSizeLookup[size]}px - 6px)` : 'unset'};
        left:  {isSwapped ? 'unset' : `calc(${$iconSizeLookup[size]}px - 6px)`};
        transition: opacity 200ms linear {opacityHoverDelay}ms;"
  bind:clientHeight={paraHeight}
>
  <svelte:component this={componentLookup[size]} {title} {isSwapped} />
</div>

<style>
  .title {
    position: absolute !important; /* Safari automatically applies inline relative style? */
    min-height: 100%;
    text-align: left;
    display: inline;
    white-space: normal;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    user-select: none;
  }

  .title.active {
    opacity: 1;
  }

  .title.inactive {
    opacity: 0;
    transition: opacity 300ms linear 0ms !important;
  }

  .title:not(.swapped) {
    justify-content: flex-start;
  }

  .title.swapped {
    justify-content: flex-end;
  }

  @media screen and (max-width: 767px) {
    .title {
      white-space: normal;
    }
  }

  :global(.swiper-slide-active .title) {
    opacity: 1;
  }

  :global(.modal .title) {
    opacity: 1;
  }

  :global(.title p:not(.swapped)) {
    text-align: left;
  }

  :global(.title p.swapped) {
    text-align: right;
  }

  :global(.title p:not(.swapped)) {
    background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.1) 15%,
        rgba(0, 0, 0, 0.8) 100%
      )
      0% 0% repeat scroll rgba(0, 0, 0, 0);
    padding: 8px 12px;
    border-radius: 0 5px 5px 0;
  }

  :global(.title p.swapped) {
    padding: 8px 12px;
    border-radius: 5px 0 0 5px;
    text-align: right;
    background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.8),
        rgba(0, 0, 0, 0.1) 85%,
        rgba(0, 0, 0, 0) 100%
      )
      0% 0% repeat scroll rgba(0, 0, 0, 0);
  }
</style>
